import React from 'react';

const BtnWarranty = ({ disabled, children } ) => {
    return (
        <div className={`btn-warranty ${disabled ? 'disabled' : ''}`}>{children}</div>
    );
};
export default BtnWarranty;
